import { apiRequest, API_BASE_URL } from './api.config';
import { ApiResponse } from '@utilities/types';

export interface ButtonOption {
    id: string;
    name: string;
    image: string;
}

export interface ButtonCategory {
    id: string;
    labelKey: string;
    options: ButtonOption[];
}

/**
 * Récupère le catalogue des boutons depuis le backend (partagé avec le front client).
 * GET /buttons/catalog
 */
export async function getButtonCatalog(): Promise<ButtonCategory[]> {
    const res = await apiRequest<ApiResponse<{ categories: ButtonCategory[] }>>('/buttons/catalog');
    const staticBase = (API_BASE_URL || '').replace(/\/api\/v1$/, '');
    return (res.data.categories || []).map((cat) => ({
        ...cat,
        options: cat.options.map((o) => ({ ...o, image: `${staticBase}${o.image}` })),
    }));
}
